import { createSlice } from "@reduxjs/toolkit";
import addEditPrice from "@custom/rtk-apis/price/addPrice";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addEditPriceSlice = createSlice({
  name: "addEditPriceSlice",
  initialState,
  reducers: {
    closePricingModal (state:any) { 
      state.status = ""; 
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addEditPrice.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addEditPrice.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addEditPrice.rejected, (state, { payload }) => {
        state.loading = false;
        state.msg =  payload.msg || 'An unexpected error occurred.';
      });
  },
});

export default addEditPriceSlice.reducer;
export const { closePricingModal } = addEditPriceSlice.actions;
